(() => {
  /* =========================================================
     KAMPŌMED – Recovery Spray + Gratis K63 Dermaroller
     ========================================================= */

  const CONFIG = {
    // Handle der Recovery-Spray-Kollektion
    recoveryCollectionHandle: 'recoveryline',

    // HIER DIE VARIANTEN-ID DES K63 EINTRAGEN:
    giftVariantId: 48558612283727,

    // Interne Kennzeichnung des automatisch hinzugefügten Geschenks
    giftProperty: '_kampomed_free_gift',
    giftPropertyValue: 'recovery-k63-september-2026'
  };

  const originalFetch = window.fetch.bind(window);

  let syncing = false;
  let recoveryVariantIds = null;

  async function getRecoveryVariantIds() {
    if (recoveryVariantIds) return recoveryVariantIds;

    const response = await originalFetch(
      `/collections/${CONFIG.recoveryCollectionHandle}/products.json?limit=250`
    );

    if (!response.ok) {
      throw new Error('Recovery-Kollektion konnte nicht geladen werden.');
    }

    const data = await response.json();

    recoveryVariantIds = new Set(
      data.products.flatMap(product =>
        product.variants.map(variant => Number(variant.id))
      )
    );

    return recoveryVariantIds;
  }

  async function getCart() {
    const response = await originalFetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    });

    return response.json();
  }

  function isOurGift(item) {
    return (
      Number(item.variant_id) === Number(CONFIG.giftVariantId) &&
      item.properties &&
      item.properties[CONFIG.giftProperty] === CONFIG.giftPropertyValue
    );
  }

  async function addGift() {
    const properties = {};
    properties[CONFIG.giftProperty] = CONFIG.giftPropertyValue;

    const response = await originalFetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(CONFIG.giftVariantId),
            quantity: 1,
            properties
          }
        ]
      })
    });

    if (!response.ok) {
      console.warn(
        'KAMPŌMED: Gratis-Dermaroller konnte nicht hinzugefügt werden.'
      );
    }
  }

  async function changeLine(itemKey, quantity) {
    await originalFetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity
      })
    });
  }

  async function refreshCartDrawer() {
    // Auf der eigentlichen Warenkorbseite ist ein Reload am zuverlässigsten.
    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }

    const cartDrawer = document.querySelector('cart-drawer');

    if (
      cartDrawer &&
      typeof cartDrawer.getSectionsToRender === 'function' &&
      typeof cartDrawer.renderContents === 'function'
    ) {
      try {
        const sectionObjects = cartDrawer.getSectionsToRender();

        const sectionNames = sectionObjects.map(section =>
          section.section || section.id
        );

        const response = await originalFetch(
          `/cart?sections=${sectionNames.join(',')}`
        );

        const sections = await response.json();

        cartDrawer.renderContents({
          sections,
          id: String(CONFIG.giftVariantId)
        });

        return;
      } catch (error) {
        console.warn('KAMPŌMED: Cart Drawer Refresh fehlgeschlagen.', error);
      }
    }

    // Aktualisiert zumindest Warenkorb-Zähler etc.,
    // falls das Theme anders konfiguriert wurde.
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );
  }

  async function syncFreeGift() {
    if (syncing) return;

    syncing = true;

    try {
      const [cart, validRecoveryVariants] = await Promise.all([
        getCart(),
        getRecoveryVariantIds()
      ]);

      // Prüfen, ob mindestens ein qualifizierendes Recovery-Produkt
      // im Warenkorb liegt.
      const hasRecoveryProduct = cart.items.some(item =>
        validRecoveryVariants.has(Number(item.variant_id))
      );

      // Nur automatisch hinzugefügte Geschenk-Zeilen finden.
      const giftLines = cart.items.filter(isOurGift);

      let cartChanged = false;

      if (hasRecoveryProduct) {
        // Noch kein Geschenk vorhanden → hinzufügen
        if (giftLines.length === 0) {
          await addGift();
          cartChanged = true;
        }

        // Falls Geschenkmenge manipuliert wurde → auf 1 setzen
        if (giftLines.length >= 1 && giftLines[0].quantity !== 1) {
          await changeLine(giftLines[0].key, 1);
          cartChanged = true;
        }

        // Doppelte automatische Geschenk-Zeilen entfernen
        if (giftLines.length > 1) {
          for (let i = 1; i < giftLines.length; i++) {
            await changeLine(giftLines[i].key, 0);
          }

          cartChanged = true;
        }
      } else {
        // Kein Recovery Spray mehr → Gratisgeschenk entfernen
        for (const giftLine of giftLines) {
          await changeLine(giftLine.key, 0);
          cartChanged = true;
        }
      }

      if (cartChanged) {
        await refreshCartDrawer();
      }
    } catch (error) {
      console.error('KAMPŌMED Free Gift:', error);
    } finally {
      syncing = false;
    }
  }

  /* ---------------------------------------------------------
     Shopify-Cart-Aktionen beobachten
     --------------------------------------------------------- */

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    try {
      const request =
        typeof args[0] === 'string'
          ? args[0]
          : args[0] && args[0].url
            ? args[0].url
            : '';

      const isCartMutation =
        request.includes('/cart/add') ||
        request.includes('/cart/change') ||
        request.includes('/cart/update') ||
        request.includes('/cart/clear');

      if (isCartMutation) {
        window.setTimeout(syncFreeGift, 250);
      }
    } catch (error) {
      // Keine Shop-Funktion wegen des Geschenk-Skripts blockieren.
    }

    return response;
  };

  // Auch beim direkten Aufruf / Reload prüfen
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.setTimeout(syncFreeGift, 300);
    });
  } else {
    window.setTimeout(syncFreeGift, 300);
  }
})();